import { FC, useEffect, useState } from "react";
import { Heading } from "@/components/Html/Heading";
import { ResponseBody } from "@/pages/api/fetchRankingData";
import { Post } from "./Post/Post";

interface Props {
  className?: string;
}

export const Ranking: FC<Props> = ({ className }) => {
  const [rankingPosts, setRankingPosts] = useState<ResponseBody[]>([]);

  useEffect(() => {
    void fetch(window.location.origin + `/api/fetchRankingData`)
      .then(async (res) => {
        setRankingPosts((await res.json()) as ResponseBody[]);
      })
      .catch(() => {
        setRankingPosts([]);
      });
  }, []);

  return (
    rankingPosts.length > 0 && (
      <div className={className}>
        <Heading heading="2" className="mb-[16px] border-b text-[24px]">
          Ranking
        </Heading>

        <div className="flex flex-col gap-[20px]">
          {rankingPosts.map((post, index) => (
            <Post key={post.sys.id} post={post} index={index + 1} />
          ))}
        </div>
      </div>
    )
  );
};
